import React, { Component } from "react";
import * as PropTypes from "prop-types";
import {
	Modal,
	Row,
	Col,
	Input,
	Spin,
	Form,
	Select,
	message,
} from "antd";

import {
	timeCardService,
	justificationsService,
} from "./../../../../redux/services";

import { API_ERRO_TYPE_CANCEL } from "./../../../../config/general";

import axios from "axios";

import moment from "moment";

import { DatePickerWithMask, HourPickerWithMask } from "./../../../../components";

class ModalCreate extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isSending: false,
			justifications: [],
			justificationsIsLoading: false,
		};

		this._axiosCancelJustificationsToken = null;
	}

	fetchJustifications = (value) => {
		if (this._axiosCancelJustificationsToken) {
			this._axiosCancelJustificationsToken.cancel(
				"Only one request allowed at a time."
			);
		}

		this._axiosCancelJustificationsToken = axios.CancelToken.source();

		if (!value.trim().length) {
			this.setState({
				justificationsIsLoading: false,
				justifications: [],
			});

			return false;
		}

		this.setState({
			justificationsIsLoading: true,
		});

		let params = {
			search: value,
			ativo: 1,
			orderBy: "nome:asc",
			cancelToken: this._axiosCancelJustificationsToken.token,
		};

		justificationsService
			.getAll({
				...params,
			})
			.then((response) => {
				this.setState({
					justificationsIsLoading: false,
					justifications: response.data.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					justificationsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	resetFields = () => {
		this.setState({
			justifications: [],
			justificationsIsLoading: false,
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onOpen = () => {};

	onSubmit = () => {
		this.form.validateFields().then((values) => {
			this.setState({
				isSending: true,
			});

			timeCardService
				.justificativaCreate({
					empresas: [this.props.empresa.id],
					departamentos: [this.props.departamento.id],
					funcionarios: [this.props.funcionario.id],
					justificativa_id: values.justificativa_id,
					data: moment(values.data).format("YYYY-MM-DD"),
					hora_inicio: values.hora_inicio + ":00",
					hora_fim: values.hora_fim + ":00",
					status: true,
				})
				.then((response) => {
					this.setState({
						isSending: false,
					});

					// Reset fields
					this.resetFields();

					// Success message
					message.success("Justificativa parcial cadastrada com sucesso.");

					// Callback
					this.props.onComplete();
				})
				.catch((data) => {
					this.setState({
						isSending: false,
					});

					Modal.error({
						title: "Ocorreu um erro!",
						content: String(data),
					});
				});
		});
	};

	render() {
		const { visible } = this.props;

		const { isSending, justifications, justificationsIsLoading } = this.state;

		return (
			<Modal
				visible={visible}
				title="Incluir Nova Justificativa Parcial"
				wrapClassName="modal-scroll"
				destroyOnClose={true}
				width={580}
				onCancel={this.onClose}
				maskClosable={false}
				okText={isSending ? "Salvando" : "Salvar"}
				cancelButtonProps={{ disabled: isSending }}
				onOk={this.onSubmit}
				confirmLoading={isSending}
				keyboard={!isSending}
				closable={!isSending}
				centered
			>
				<Form
					ref={(el) => (this.form = el)}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					disabled={isSending}
					initialValues={{
						data: moment(this.props.dataDia),
					}}
				>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item label="Empresa" style={{ marginBottom: 15 }}>
								{this.props.empresa?.nome ?? "-"}
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item label="Departamento" style={{ marginBottom: 15 }}>
								{this.props.departamento?.nome ?? "-"}
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item label="Funcionário" style={{ marginBottom: 15 }}>
								{this.props.funcionario?.nome ?? "-"}
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item
								name="justificativa_id"
								label="Justificativa"
								rules={[{ required: true, message: "Campo obrigatório." }]}
							>
								<Select
									filterOption={false}
									allowClear
									placeholder="Selecione a justificativa"
									notFoundContent={
										justificationsIsLoading ? (
											<Spin
												indicator={
													<i className="fad fa-spinner-third fa-spin" />
												}
											/>
										) : null
									}
									onSearch={this.fetchJustifications}
									showSearch
								>
									{justifications.map((item, index) => (
										<Select.Option key={index} value={item.id}>
											{item.nome}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						<Col span={24}>
							<DatePickerWithMask disabled={true} label="Data" name="data" required={true} />
						</Col>
						<Col xs={24} md={12}>
							<HourPickerWithMask name="hora_inicio" label="Hora início" required={true} allowMoreThan24={false} />
						</Col>
						<Col xs={24} md={12}>
							<HourPickerWithMask name="hora_fim" label="Hora fim" required={true} allowMoreThan24={false} />
						</Col>
					</Row>
				</Form>
			</Modal>
		);
	}
}

export default ModalCreate;